<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex with-button">
        <div class="p-2">
          <h1 class="title">알림톡 템플릿 관리</h1>
        </div>
        <div class="p-2 small bottom">
          총 <strong><span class="number mint">{{tableData.length}}</span></strong> 건
        </div>

        <div class="ml-auto p-2">
          <button type="button" class="btn gray" @click="retrieveTemplate">API STORE 템플릿 업데이트</button>
        </div>
      </div>

      <div class="d-flex">
        <div class="p-2 w-100">
          <div class="input-group search">
            <div class="input-group-prepend">
              <span class="input-group-text"><i class="fas fa-search"></i></span>
            </div>
            <input type="text" class="form-control" aria-describedby="basic-addon1" v-model="search.template_msg" @keyup.enter="retrieve" placeholder="템플릿 내용">
            <div class="input-group-apend">
              <button type="button" class="btn btn-default" @click="retrieve">
                 검색
              </button>
            </div>
          </div>
        </div>
        <div class="p-2 search-detail" v-if="searchDetailVisible">
          <a href="#" class="arrowdown"><i class="fas fa-angle-double-down"></i></a>
        </div>
      </div>
    </div>
    <!-- 그리드 -->
    <stone-data-table
      :loading="searchLoading"
      :columns="tableColumns"
      :data="tableData"
      :table-props="defaultTableProps"
      @row-click="rowClickHandler">
    </stone-data-table>

    <el-dialog title="템플릿 상세" :visible.sync="dialogVisible" @closed="closedDialogHandler" append-to-body>
      <el-form :model="frm" :rules="rules" ref="frm" label-width="120px" class="demo-form">
        <el-form-item label="템플릿코드">
          {{frm.template_code}}
        </el-form-item>
         <el-form-item label="템플릿명">
          {{frm.template_name}}
        </el-form-item>
        <el-form-item label="메세지 내용">
          <div style="background-color: #eee;" v-html="replaceCarriageReturnToBr(frm.template_msg)"></div>
        </el-form-item>
        <el-form-item label="버튼">
          {{frm.btn_type}} / {{frm.btn_name}} / {{frm.btn_url1}} / {{frm.btn_url2}}
        </el-form-item>
        <el-form-item label="등록상태">
          {{frm.status}}
        </el-form-item>
        <el-form-item label="발신번호" prop="callback">
          <!-- <el-input v-model.trim="frm.callback" :maxlength="13" placeholder="- 없이 입력하십시오."></el-input> -->
          <el-select v-model="frm.callback" placeholder="발신번호를 선택하십시오">
            <el-option v-for="item in callbackData" :key="item.send_number" :label="`${item.send_number} - ${item.send_comment}`" :value="item.send_number">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="실패시 전송 타입" prop="failed_type">
          <el-select v-model="frm.failed_type" placeholder="전송타입을 선택하십시오" @change="changeFailedTypeHandler">
            <el-option v-for="type in failedTypes" :label="type.code_name" :value="type.code_id" :key="type.code_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="실패시 전송 제목" prop="failed_subject">
          <el-input v-model.trim="frm.failed_subject" :maxlength="50" :disabled="disabledSubject"></el-input>
        </el-form-item>
        <el-form-item label="실패시 전송 내용" prop="failed_msg">
          <el-input type="textarea" v-model.trim="frm.failed_msg" :maxlength="100" :disabled="disabledMsg"></el-input>
        </el-form-item>
        <div class="text-right">
          <el-button @click="dialogVisible = false">닫기</el-button>
          <el-button type="primary" @click="modify">저장</el-button>
        </div>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>

import common from '@/modules/common'

export default {
  name: 'M990701',
  mixins: [common.mixins],
  data () {
    return {
      frm: {
        template_code: '',
        template_name: '',
        template_msg: '',
        status: '',
        status_code: '',
        btn_type: '',
        btn_name: '',
        btn_url1: '',
        btn_url2: '',
        callback: '',
        failed_type: '',
        failed_subject: '',
        failed_msg: ''
      },
      callbackData: [],
      dialogVisible: false,
      disabledSubject: true,
      disabledMsg: true,
      tableData: [],
      tableColumns: [
        {label: '템플릿코드', prop: 'template_code', align: 'center', width: 80},
        {label: '템플릿명', prop: 'template_name', align: 'left', width: 100},
        {label: '템플릿 내용', prop: 'template_msg', align: 'left', width: 300},
        {label: '등록상태', prop: 'status', align: 'center', width: 80},
        {label: '발신번호', prop: 'callback', align: 'center', width: 80, formatter: this.columnFormatterPhone},
        {label: '실패전송타입', prop: 'failed_type_name', align: 'center', width: 100},
        {label: '실패전송제목', prop: 'failed_subject', align: 'left', width: 100},
        {label: '실패전송메세지', prop: 'failed_msg', align: 'left', width: 200}
      ],
      failedTypes: [],
      search: {
        template_msg: ''
      },
      rules: {
        callback: [
          { required: true, message: '발신번호를 선택하십시오.', trigger: 'change' }
          // { required: true, message: '발신 전화번호를 입력하십시오.', trigger: 'blur' },
          // { type: 'string', pattern: /^[0-9]/, message: '숫자만 가능합니다.' },
          // { type: 'string', pattern: /^01([0|1|6|7|8|9]?)-?(\d{3,4})-?(\d{4})$/, message: '전화번호 형식에 맞지 않습니다.' }
        ],
        failed_type: [
          { required: true, message: '실패시 전송할 타입을 선택하십시오.', trigger: 'change' }
        ],
        failed_subject: [
          { required: false, message: '실패시 전송할 제목을 입력하십시오.', trigger: 'blur' }
        ],
        failed_msg: [
          { required: false, message: '실패시 전송할 내용을 입력하십시오.', trigger: 'blur' }
        ]
      }
    }
  },
  beforeCreate () {
  },
  created () {
    common.axios.get('/code/KAKAO_FAILED_TYPE/child')
      .then(response => {
        this.failedTypes = response.data
      })
    this.retrieveCallback()
    this.retrieve()
  },
  mounted () {
  },
  methods: {
    modify () {
      this.$refs['frm'].validate(valid => {
        if (valid) {
          this.frm.callback = this.getOnlyNumber(this.frm.callback)
          common.axios.put('/kakao/template', this.frm)
            .then(response => {
              if (response.data.status === 1) {
                this.$message('수정하였습니다.')
                this.dialogVisible = false
                this.retrieve()
              }
            })
        }
      })
    },
    retrieveTemplate () {
      common.axios.post('/kakao/template/store', {})
        .then(response => {
          this.$message('템플릿 정보가 업데이트 되었습니다.')
          this.retrieve()
        })
    },
    retrieveCallback () {
      common.axios.post('/kakao/callback/list', {})
        .then(response => {
          this.callbackData = response.data
        })
    },
    retrieve () {
      common.axios.post('/kakao/template/list', this.search)
        .then(response => {
          this.tableData = response.data
        })
    },
    rowClickHandler (row, event, column) {
      if (row.status_code !== '3') {
        this.$message.warning('등록상태가 "승인"인 템플릿만 수정할 수 있습니다.')
        return
      }
      Object.keys(this.frm).forEach(key => {
        this.frm[key] = this.isEmpty(row[key]) ? '' : row[key]
      })
      this.changeFailedTypeHandler(row.failed_type, false)
      this.dialogVisible = true
    },
    changeFailedTypeHandler (value, isInitValue = true) {
      if (value === 'SMS') {
        if (isInitValue) {
          // this.frm.failed_subject = ''
        }
        this.rules.failed_subject[0].required = true
        this.rules.failed_msg[0].required = true
        this.disabledSubject = false
        this.disabledMsg = false
      } else if (value === 'LMS') {
        this.rules.failed_subject[0].required = true
        this.rules.failed_msg[0].required = true
        this.disabledSubject = false
        this.disabledMsg = false
      } else {
        if (isInitValue) {
          this.frm.failed_subject = ''
          this.frm.failed_msg = ''
        }
        this.rules.failed_subject[0].required = false
        this.rules.failed_msg[0].required = false
        this.disabledSubject = true
        this.disabledMsg = true
      }
    },
    closedDialogHandler () {
      Object.keys(this.frm).forEach(key => {
        this.frm[key] = ''
      })
      this.rules.failed_subject[0].required = false
      this.rules.failed_msg[0].required = false
      this.disabledSubject = true
      this.disabledMsg = true
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/M990701.vue